'use client';
import { Typography } from '@curology/ui-components-web/react/Typography';
import Link from 'next/link';
import React from 'react';

import { urls } from '@/utils/urls';

const TreatmentOptions = () => (
  <>
    <Link
      className="cur-cursor-pointer cur-min-h-[100px] cur-mx-[1.25rem] cur-pt-[20px] hover:cur-underline cur-border-b cur-border-[#ededf0] cur-block"
      href={urls.app.signupFlow('hair')}
    >
      <Typography size="h3">Hair</Typography>
      <Typography className="cur-pb-[1.25rem]">
        Fight hair loss and boost hair growth
      </Typography>
    </Link>
    <Link
      className="cur-cursor-pointer cur-min-h-[100px] cur-mx-[1.25rem] cur-pt-[20px] hover:cur-underline cur-block"
      href={urls.app.signupFlow('skin')}
    >
      <Typography size="h3">Skin</Typography>
      <Typography className="cur-pb-[1.25rem]">
        Tackle acne or get a head start on preventative aging
      </Typography>
    </Link>
  </>
);

export default TreatmentOptions;
